<template>
  <v-form
    v-if="taxRate"
  >
    <translations-tabs>
      <template #default="{language}">
        <v-layout row>
          <v-flex
            xs6
            pr-2
          >
            <translatable
              :language="language"
              v-model="taxRate"
              field-name="name"
            >
              <template
                #default="{ fieldValue, fieldMutator }"
              >
                <v-text-field
                  v-model="fieldValue"
                  :error-messages="taxRate.displayErrors('name')"
                  :label="$t('Tax name')"
                  outline
                  @change="fieldMutator(fieldValue)"
                />
              </template>
            </translatable>
          </v-flex>
          <v-flex
            xs6
            pl-2
          >
            <v-text-field
              v-model="taxRate.rate"
              :error-messages="taxRate.displayErrors('rate')"
              :disabled="language && !language.default"
              :label="$t('Tax rate')"
              outline
            />
          </v-flex>
        </v-layout>
      </template>
    </translations-tabs>
  </v-form>
</template>

<script>
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import Translatable from '@/components/widgets/Translatable'

export default {
  name: 'SettingsTaxRateForm',

  components: { Translatable, TranslationsTabs },

  props: {
    taxRate: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
